import { render, staticRenderFns } from "./WaitingApprovalLabel.vue?vue&type=template&id=f5a99ef6&"
import script from "./WaitingApprovalLabel.vue?vue&type=script&lang=js&"
export * from "./WaitingApprovalLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports